import { useState, useEffect } from "react";

const navItems = [
  { label: "Home", id: "hero" },
  { label: "About", id: "about" },
  { label: "Highlights", id: "highlights" },
  { label: "Social", id: "social" },
  { label: "Gallery", id: "gallery" },
  { label: "Contact", id: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-urban-dark/95 backdrop-blur-md border-b border-red-900/40 shadow-lg shadow-black/50"
          : ""
      }`}
    >
      <div className="px-8 py-4 flex items-center justify-between">
        <button onClick={() => scrollTo("hero")} className="flex items-center gap-3 cursor-pointer whitespace-nowrap">
          <div className="w-12 h-12 flex items-center justify-center">
            <img
              src="https://public.readdy.ai/ai/img_res/eae5b4cf-72f5-4242-8c48-d94be5569ffc.png"
              alt="Old Man Murks Logo"
              className="w-12 h-12 rounded-full object-cover border-2 border-red-600 animate-pulse-red"
            />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-bebas text-xl text-white tracking-widest">OLD MAN MURKS</span>
            <span className="font-rajdhani text-xs text-red-500 uppercase tracking-widest">Mike Barrett</span>
          </div>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="font-rajdhani font-600 uppercase tracking-widest text-sm text-gray-400 hover:text-red-500 transition-colors duration-300 cursor-pointer whitespace-nowrap relative group"
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-red-600 group-hover:w-full transition-all duration-300" />
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            className="font-rajdhani font-semibold uppercase tracking-widest text-xs bg-red-700 hover:bg-red-600 text-white px-5 py-2 rounded-sm transition-colors duration-300 cursor-pointer whitespace-nowrap border border-red-600"
          >
            Get In Touch
          </button>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden flex flex-col gap-1.5 cursor-pointer w-8 h-8 items-center justify-center"
        >
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-urban-dark/98 border-t border-red-900/30 px-8 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="font-rajdhani font-semibold uppercase tracking-widest text-sm text-gray-300 hover:text-red-500 transition-colors text-left cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
